import { render, staticRenderFns } from "./AccordiFilters.vue?vue&type=template&id=d8741140&scoped=true"
import script from "./AccordiFilters.vue?vue&type=script&lang=js"
export * from "./AccordiFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8741140",
  null
  
)

export default component.exports